import React from "react"
import types from "prop-types"
import Modal, { ModalHeader } from "shared/Modal"
import EDIT_SUBMISSION_MODAL_STYLE from "./editSubmissionModalStyle"
import SubmissionFormTypeConverter from "./SubmissionFormTypeConverter"

const ChangeSubmissionFormTypeModal = ({ close, isOpen }) => (
  <Modal isOpen={isOpen} style={EDIT_SUBMISSION_MODAL_STYLE}>
    <ModalHeader
      closeModal={close}
      heading="Change Form Type"
    />
    <p className="text-sm text-center text-gray mb-8 w-5/6 mx-auto">
      Only answers to reporting fields will be retained.
      All other answers must be manually entered.
    </p>
    <SubmissionFormTypeConverter
      onCancel={close}
      onFormTypeChange={close}
    />
  </Modal>
)

ChangeSubmissionFormTypeModal.propTypes = {
  close: types.func.isRequired,
  isOpen: types.bool.isRequired,
}

export default ChangeSubmissionFormTypeModal
